const getbrowserFieldsFor3ds = () => {
  return {
    browserJavaEnabled: navigator.javaEnabled?.(),
    userAgent: navigator.userAgent,
    browserLanguage: navigator.language,
    browserColorDepth: window.screen.colorDepth,
    browserScreenHeight: window.screen.height,
    browserScreenWidth: window.screen.width,
    browserTimeZone: new Date().getTimezoneOffset(),
    deviceChannel: 'Browser',
    browserJavascriptEnabled: true,
  };
};

export default getbrowserFieldsFor3ds;
